import "./index.scss";
import React from "react";
import classnames from "classnames";

const cls = "NewsCard";

export interface INewsCardProps {
  className?: string;
  description: string;
  imageSrc: string;
}

export const NewsCard: React.SFC<INewsCardProps> = props => {
  const { className, description, imageSrc } = props;
  return (
    <div className={classnames(cls, className)}>
      <div className={`${cls}-imageWrap`}>
        <img className={`${cls}-image`} src={imageSrc} />
      </div>
      <div className={`${cls}-description`}>
        <div className={`${cls}-descriptionContent`}>{description}</div>
      </div>
    </div>
  );
};
